import { Component } from '@angular/core';
import { SpinnerService } from '@services/spinner.service';

@Component({
  standalone: false,
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  loading: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.spinnerService.isLoading.subscribe((loading) => {
      this.loading = loading;
    });
  }
}
